/* tslint:disable */
/* eslint-disable */
/**
 * Application
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, RequiredError } from '../base';
// @ts-ignore
import { ApiErrorResponse } from '../model';
// @ts-ignore
import { GiftCardAvailableAmountResponse } from '../model';
// @ts-ignore
import { GiftCardUserResponse } from '../model';
// @ts-ignore
import { PaymentRequest } from '../model';
// @ts-ignore
import { PaymentResponse } from '../model';
/**
 * GiftCardPaymentApiApiGiftCardPaymentCancelTransactionGet - axios parameter creator
 * 
 * @param {string} [giftCardCode] 
 * @param {string} [reference] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function GiftCardPaymentApiApiGiftCardPaymentCancelTransactionGetAxiosParamCreator (giftCardCode?: string, reference?: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/GiftCardPayment/cancel-transaction`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    if (giftCardCode !== undefined) {
        localVarQueryParameter['giftCardCode'] = giftCardCode;
    }

    if (reference !== undefined) {
        localVarQueryParameter['reference'] = reference;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * GiftCardPaymentApiApiGiftCardPaymentGetAvailableAmountGet - axios parameter creator
 * 
 * @param {string} [giftCardCode] 
 * @param {number} [amount] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function GiftCardPaymentApiApiGiftCardPaymentGetAvailableAmountGetAxiosParamCreator (giftCardCode?: string, amount?: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/GiftCardPayment/get-available-amount`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    if (giftCardCode !== undefined) {
        localVarQueryParameter['giftCardCode'] = giftCardCode;
    }

    if (amount !== undefined) {
        localVarQueryParameter['amount'] = amount;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * GiftCardPaymentApiApiGiftCardPaymentGetBalanceGet - axios parameter creator
 * 
 * @param {string} [giftCardCode] 
 * @param {number} [amount] 
 * @param {string} [billCode] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function GiftCardPaymentApiApiGiftCardPaymentGetBalanceGetAxiosParamCreator (giftCardCode?: string, amount?: number, billCode?: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/GiftCardPayment/get-Balance`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    if (giftCardCode !== undefined) {
        localVarQueryParameter['giftCardCode'] = giftCardCode;
    }

    if (amount !== undefined) {
        localVarQueryParameter['Amount'] = amount;
    }

    if (billCode !== undefined) {
        localVarQueryParameter['billCode'] = billCode;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * GiftCardPaymentApiApiGiftCardPaymentPaymentConfirmGet - axios parameter creator
 * 
 * @param {string} [cardCode] 
 * @param {string} [reference] 
 * @param {string} [mobileNumber] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function GiftCardPaymentApiApiGiftCardPaymentPaymentConfirmGetAxiosParamCreator (cardCode?: string, reference?: string, mobileNumber?: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/GiftCardPayment/payment-confirm`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    if (cardCode !== undefined) {
        localVarQueryParameter['cardCode'] = cardCode;
    }

    if (reference !== undefined) {
        localVarQueryParameter['reference'] = reference;
    }

    if (mobileNumber !== undefined) {
        localVarQueryParameter['mobileNumber'] = mobileNumber;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * GiftCardPaymentApiApiGiftCardPaymentPaymentRequestPost - axios parameter creator
 * 
 * @param {PaymentRequest} [paymentRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function GiftCardPaymentApiApiGiftCardPaymentPaymentRequestPostAxiosParamCreator (paymentRequest?: PaymentRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/GiftCardPayment/payment-request`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(paymentRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * GiftCardPaymentApiApiGiftCardPaymentRefundRequestPost - axios parameter creator
 * 
 * @param {PaymentRequest} [paymentRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function GiftCardPaymentApiApiGiftCardPaymentRefundRequestPostAxiosParamCreator (paymentRequest?: PaymentRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/GiftCardPayment/refund-request`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(paymentRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}

/**
 * Request parameters for apiGiftCardPaymentCancelTransactionGet operation in GiftCardPaymentApi.
 * @export
 * @interface GiftCardPaymentApiApiGiftCardPaymentCancelTransactionGetRequest
 */
export interface GiftCardPaymentApiApiGiftCardPaymentCancelTransactionGetRequest {
    /**
     * 
     * @type {string}
     * @memberof GiftCardPaymentApiApiGiftCardPaymentCancelTransactionGet
     */
    readonly giftCardCode?: string

    /**
     * 
     * @type {string}
     * @memberof GiftCardPaymentApiApiGiftCardPaymentCancelTransactionGet
     */
    readonly reference?: string
}

/**
 * Request parameters for apiGiftCardPaymentGetAvailableAmountGet operation in GiftCardPaymentApi.
 * @export
 * @interface GiftCardPaymentApiApiGiftCardPaymentGetAvailableAmountGetRequest
 */
export interface GiftCardPaymentApiApiGiftCardPaymentGetAvailableAmountGetRequest {
    /**
     * 
     * @type {string}
     * @memberof GiftCardPaymentApiApiGiftCardPaymentGetAvailableAmountGet
     */
    readonly giftCardCode?: string

    /**
     * 
     * @type {number}
     * @memberof GiftCardPaymentApiApiGiftCardPaymentGetAvailableAmountGet
     */
    readonly amount?: number
}

/**
 * Request parameters for apiGiftCardPaymentGetBalanceGet operation in GiftCardPaymentApi.
 * @export
 * @interface GiftCardPaymentApiApiGiftCardPaymentGetBalanceGetRequest
 */
export interface GiftCardPaymentApiApiGiftCardPaymentGetBalanceGetRequest {
    /**
     * 
     * @type {string}
     * @memberof GiftCardPaymentApiApiGiftCardPaymentGetBalanceGet
     */
    readonly giftCardCode?: string

    /**
     * 
     * @type {number}
     * @memberof GiftCardPaymentApiApiGiftCardPaymentGetBalanceGet
     */
    readonly amount?: number

    /**
     * 
     * @type {string}
     * @memberof GiftCardPaymentApiApiGiftCardPaymentGetBalanceGet
     */
    readonly billCode?: string
}

/**
 * Request parameters for apiGiftCardPaymentPaymentConfirmGet operation in GiftCardPaymentApi.
 * @export
 * @interface GiftCardPaymentApiApiGiftCardPaymentPaymentConfirmGetRequest
 */
export interface GiftCardPaymentApiApiGiftCardPaymentPaymentConfirmGetRequest {
    /**
     * 
     * @type {string}
     * @memberof GiftCardPaymentApiApiGiftCardPaymentPaymentConfirmGet
     */
    readonly cardCode?: string

    /**
     * 
     * @type {string}
     * @memberof GiftCardPaymentApiApiGiftCardPaymentPaymentConfirmGet
     */
    readonly reference?: string

    /**
     * 
     * @type {string}
     * @memberof GiftCardPaymentApiApiGiftCardPaymentPaymentConfirmGet
     */
    readonly mobileNumber?: string
}

/**
 * Request parameters for apiGiftCardPaymentPaymentRequestPost operation in GiftCardPaymentApi.
 * @export
 * @interface GiftCardPaymentApiApiGiftCardPaymentPaymentRequestPostRequest
 */
export interface GiftCardPaymentApiApiGiftCardPaymentPaymentRequestPostRequest {
    /**
     * 
     * @type {PaymentRequest}
     * @memberof GiftCardPaymentApiApiGiftCardPaymentPaymentRequestPost
     */
    readonly paymentRequest?: PaymentRequest
}

/**
 * Request parameters for apiGiftCardPaymentRefundRequestPost operation in GiftCardPaymentApi.
 * @export
 * @interface GiftCardPaymentApiApiGiftCardPaymentRefundRequestPostRequest
 */
export interface GiftCardPaymentApiApiGiftCardPaymentRefundRequestPostRequest {
    /**
     * 
     * @type {PaymentRequest}
     * @memberof GiftCardPaymentApiApiGiftCardPaymentRefundRequestPost
     */
    readonly paymentRequest?: PaymentRequest
}

/**
* 
* @param {GiftCardPaymentApiApiGiftCardPaymentCancelTransactionGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function GiftCardPaymentApiApiGiftCardPaymentCancelTransactionGet(requestParameters: GiftCardPaymentApiApiGiftCardPaymentCancelTransactionGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await GiftCardPaymentApiApiGiftCardPaymentCancelTransactionGetAxiosParamCreator(requestParameters.giftCardCode, requestParameters.reference, options, configuration);
    const request: () => AxiosPromise<GiftCardAvailableAmountResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {GiftCardPaymentApiApiGiftCardPaymentGetAvailableAmountGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function GiftCardPaymentApiApiGiftCardPaymentGetAvailableAmountGet(requestParameters: GiftCardPaymentApiApiGiftCardPaymentGetAvailableAmountGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await GiftCardPaymentApiApiGiftCardPaymentGetAvailableAmountGetAxiosParamCreator(requestParameters.giftCardCode, requestParameters.amount, options, configuration);
    const request: () => AxiosPromise<GiftCardAvailableAmountResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {GiftCardPaymentApiApiGiftCardPaymentGetBalanceGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function GiftCardPaymentApiApiGiftCardPaymentGetBalanceGet(requestParameters: GiftCardPaymentApiApiGiftCardPaymentGetBalanceGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await GiftCardPaymentApiApiGiftCardPaymentGetBalanceGetAxiosParamCreator(requestParameters.giftCardCode, requestParameters.amount, requestParameters.billCode, options, configuration);
    const request: () => AxiosPromise<GiftCardUserResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {GiftCardPaymentApiApiGiftCardPaymentPaymentConfirmGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function GiftCardPaymentApiApiGiftCardPaymentPaymentConfirmGet(requestParameters: GiftCardPaymentApiApiGiftCardPaymentPaymentConfirmGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await GiftCardPaymentApiApiGiftCardPaymentPaymentConfirmGetAxiosParamCreator(requestParameters.cardCode, requestParameters.reference, requestParameters.mobileNumber, options, configuration);
    const request: () => AxiosPromise<PaymentResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {GiftCardPaymentApiApiGiftCardPaymentPaymentRequestPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function GiftCardPaymentApiApiGiftCardPaymentPaymentRequestPost(requestParameters: GiftCardPaymentApiApiGiftCardPaymentPaymentRequestPostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await GiftCardPaymentApiApiGiftCardPaymentPaymentRequestPostAxiosParamCreator(requestParameters.paymentRequest, options, configuration);
    const request: () => AxiosPromise<PaymentResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {GiftCardPaymentApiApiGiftCardPaymentRefundRequestPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function GiftCardPaymentApiApiGiftCardPaymentRefundRequestPost(requestParameters: GiftCardPaymentApiApiGiftCardPaymentRefundRequestPostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await GiftCardPaymentApiApiGiftCardPaymentRefundRequestPostAxiosParamCreator(requestParameters.paymentRequest, options, configuration);
    const request: () => AxiosPromise<PaymentResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
